import styled from "styled-components";
import { ModalBody } from "react-bootstrap";

export const ModalBodyWrapper = styled(ModalBody)`
    font-size: 14px;

    & .form-control {
        font-size: 14px !important
    }

    & table.table > thead > tr > th {
        background-color: #133366;
        color: white;
    }

    & table.table > tbody > tr > td {
        vertical-align: middle;
    }
`;

export const SectionWrapper = styled.div`
    padding: 5px;
    background-color: #ddd;
    border-radius: 3px;
    margin-bottom: 10px;

    & > label {
        margin-bottom: 0px;
    }
`;

export const ActionsRowWrapper = styled.div`
    height: 36px;

    & > label.col-lg-3.col-xs-12.control-label {
        padding-top: 6px;
    }

     > div.col-lg-9.col-xs-12 {
         padding-top: 4px;
     }
`;